<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-btn v-if="isNew" slot="activator" outline>
      <v-icon>add</v-icon>Add New Competition
    </v-btn>
    <v-btn v-else slot="activator" outline>
      <v-icon>create</v-icon>Edit Competition
    </v-btn>

    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-title>
          <span class="headline">{{headline}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Competition Name*"
                  v-model="name"
                  :rules="requiredRule"
                  required
                  hint="Name of this Competition"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Description" v-model="description"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="[{text:'By Time', value:'ls'}, {text:'By Score', value:'hs'}]"
                  label="Primary Scoring Method*"
                  v-model="scoreOrdering"
                  :rules="requiredRule"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  v-model="sDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="startDate"
                    label="Start Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="startDate" no-title @input="sDateMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm6>
                <v-menu
                  v-model="eDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="endDate"
                    label="End Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="endDate" no-title @input="eDateMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12>
                <v-text-field label="Rules URL" v-model="rulesUrl" :rules="urlRule"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Image URL" v-model="imageUrl" :rules="urlRule"></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-select :items="matChoices" v-model="matFiles" label="Mat Files"></v-select>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
/*global firebase*/
/*

TODO: simplify scoreing logic:

That said, since we control the competition format, we can restrict it to only counting up with time, 
so lower time is always better, and only increasing score. It is more important I think to be able to 
choose whether time is the primary scoring method, or score is primary, with the other as secondary.

multiple submissions by user -- we can roll it up so the user is on the leaderboard only once -- best score based on competition format

*/
export default {
  props: {
    isNew: Boolean,
    id: String,
    obj: Object
  },
  data: () => ({
    dialog: false,
    valid: true,
    name: "",
    requiredRule: [v => !!v || "Required"],
    description: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    scoreOrdering: "",
    startDate: new Date().toISOString().substr(0, 10),
    sDateMenu: false,
    endDate: new Date().toISOString().substr(0, 10),
    eDateMenu: false,
    rulesUrl: "",
    imageUrl: "",
    urlRule: [
      v =>
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/.test(
          v
        ) || "URL must be valid"
    ],
    headline: "",
    matFiles: "",
    matChoices: [
      {
        text: "CompFollowTheLineBeginner",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompFollowTheLineBeginner.zip"
      },
      {
        text: "CompFollowTheLineExpert",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompFollowTheLineExpert.zip"
      },
      {
        text: "CompKegelRingBeginner",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompKegelRingBeginner.zip"
      },
      {
        text: "CompKegelRingExpert",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompKegelRingExpert.zip"
      },
      {
        text: "CompMazeBeginner",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompMazeBeginner.zip"
      },
      {
        text: "CompMazeExpert",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompMazeExpert.zip"
      },
      {
        text: "CompetitionCleanup",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompetitionCleanup.zip"
      },
      {
        text: "CompetitionDemo",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompetitionDemo.zip"
      },
      {
        text: "CompetitionHydrodynamics",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompetitionHydrodynamics.zip"
      },
      {
        text: "CompetitionTest",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompetitionTest.zip"
      },
      {
        text: "CompetitionVacuum",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/CompetitionVacuum.zip"
      },
      {
        text: "FLL2018Comp",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/FLL2018Comp.zip"
      },
      {
        text: "IntoOrbitComp",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/IntoOrbitComp.zip"
      },
      {
        text: "WRO Booth",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/WRO%20Booth.zip"
      },
      {
        text: "WRO2018ElemComp",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/WRO2018ElemComp.zip"
      },
      {
        text: "WRO2018ElemCompUS",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/WRO2018ElemCompUS.zip"
      },
      {
        text: "WROChallenge",
        value:
          "https://cogmation.s3.amazonaws.com/downloads/Competitions/WROChallenge.zip"
      },
      {
        text: "SmartLighting",
        value:
          "https://cogmation.s3.us-west-2.amazonaws.com/downloads/Competitions/SmartLighting.zip"
      },
      {
        text: "SmartNetwork",
        value:
          "https://cogmation.s3.us-west-2.amazonaws.com/downloads/Competitions/SmartNetwork.zip"
      },
      {
        text: "SmartPassengerTransport",
        value:
          "https://cogmation.s3.us-west-2.amazonaws.com/downloads/Competitions/SmartPassengerTransport.zip"
      }
    ]
  }),
  created() {
    if (this.isNew) {
      this.headline = "New Competition";
    } else {
      this.headline = "Edit Competition";
      this.name = this.obj.name
      this.description = this.obj.description
      this.scoreOrdering = this.obj.isAscending?'ls':'hs'
      this.startDate = new Date(this.obj.startDate).toISOString().substr(0, 10)
      this.endDate = new Date(this.obj.endDate).toISOString().substr(0, 10)
      this.rulesUrl = this.obj.rulesUrl
      this.imageUrl = this.obj.imageUrl
      this.matFiles = this.obj.matFiles
    }
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        let submitData = {
          name: this.name,
          description: this.description,
          isAscending: this.scoreOrdering == 'ls',
          startDate: new Date(this.startDate + "T12:00:00").getTime(),
          endDate: new Date(this.endDate + "T12:00:00").getTime(),
          rulesUrl: this.rulesUrl,
          imageUrl: this.imageUrl,
          matFiles: this.matFiles
        };

        console.log("save");
        console.log(submitData);

        if (this.isNew) {
          let newCompetitionKey = firebase
            .database()
            .ref()
            .child("competitions")
            .push(submitData).key;
          console.log("created competition with key: " + newCompetitionKey);
          // clear form
          this.$refs.form.reset();
        } else {
          // update
          firebase
            .database()
            .ref("/competitions/" + this.id)
            .update(submitData);
        }
        // close dialog
        this.dialog = false;
      }
    }
  }
};
</script>
